<template>
    <div class="containerChat">
        <div class="wrapper">
            <input type="checkbox" v-model="isChecked" id="toggle-checkbox" />
            <label for="toggle-checkbox" class="fab"></label>
            <div class="fac" :class="{ 'active': isChecked }">
                <div class="contentIconsAndText" v-for="(item, index) in props?.listData" :key="'chatList' + index">
                    <span @click="actionClick(item?.href)">
                        <p>{{ item?.text }}</p>
                    </span>
                    <div @click="actionClick(item?.href)" class="contentIconStyle"><img :src="getImageSrc(item?.imgType ?? '')" alt="icon" width="32px" height="32px"
                            aria-label="icono de ayuda" /></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { ref, defineProps } from 'vue';
import iconChat from '../../assets/chatIcons/iconChat.png';
import calendar from '../../assets/chatIcons/calendar.png';
import call from '../../assets/chatIcons/call.png';
import email from '../../assets/chatIcons/email.png';
import writing from '../../assets/chatIcons/writing.png';
import contacts from '../../assets/chatIcons/contacts.png';

const props = defineProps({
    listData: {
        default: []
    }
})
const isChecked = ref(false);

const actionClick = (href) => {
    if (href) window.location.href = href;
}
const getImageSrc = (alerttype) => {
    const imageMap = {
        calendar,
        contacts,
        writing,
        email,
        call,
    };
    if (alerttype) return imageMap[alerttype];
    else return iconChat
}

</script>

<style scoped>
.contentIconsAndText .contentIconStyle {
    background: #EBFEF6;
    border: 2px #A4F6D5 solid;
    border-radius: 60px;
    height: 50px;
    width: 50px;
    margin-bottom: 16px;
    align-content: center;
    text-align: center;

    img {
        margin-top: 3px;
    }
}

.contentIconsAndText span {
    position: absolute;
    right: 61px;
    height: 50px;
    align-content: center;
    white-space: nowrap;
}

.containerChat {
    position: fixed;
    bottom: 30px;
    right: 30px;
}

.wrapper {
    width: 50px;
    height: 50px;
    position: relative;
    border-radius: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 6rem;
}

.wrapper label.fab {
    background: url('../../assets/chatIcons/iconChat.png') no-repeat center center;
    background-size: cover;
    width: 50px;
    height: 50px !important;
    position: relative;
    cursor: pointer;
    z-index: 3;
    border-radius: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    animation: fab-animation-reverse 0.4s ease-out forwards;
    -webkit-box-shadow: 0px 0px 10px 5px rgba(0, 0, 0, 0.13);
    -moz-box-shadow: 0px 0px 10px 5px rgba(0, 0, 0, 0.13);
    box-shadow: 0px 0px 10px 5px rgba(0, 0, 0, 0.13);
}

.wrapper input:checked~label.fab {
    background: url('../../assets/chatIcons/closeChat.png') no-repeat center center;
    background-size: cover;
    cursor: pointer;
    /* Remover animaciones para evitar giros */
    animation: none;
    -webkit-box-shadow: 0px 0px 10px 5px rgba(0, 0, 0, 0.13);
    -moz-box-shadow: 0px 0px 10px 5px rgba(0, 0, 0, 0.13);
    box-shadow: 0px 0px 10px 5px rgba(0, 0, 0, 0.13);
}

.wrapper .fac {
    width: 32px;
    height: 150px;
    border-radius: 64px;
    position: absolute;
    z-index: 2;
    padding: 0.5rem 0.5rem;
    opacity: 0;
    display: flex;
    flex-direction: column;
    justify-content: end;
    align-items: center;
    transition: opacity 0.2s ease-in, top 0.2s ease-in, width 0.1s ease-in;
}

.contentIconsAndText .contentIconStyle,
.contentIconsAndText span p {
    -webkit-box-shadow: 0px 0px 10px 5px rgba(0, 0, 0, 0.13);
    -moz-box-shadow: 0px 0px 10px 5px rgba(0, 0, 0, 0.13);
    box-shadow: 0px 0px 10px 5px rgba(0, 0, 0, 0.13);
    cursor: pointer
}

.contentIconsAndText span p {
    height: 27px;
    align-content: center;
    padding-inline: 12px;
    border-radius: 15px;
    background: #EBFEF6;
    font-family: Rubik-semibold, sans-serif;
    color: #012D25;
}

.wrapper .fac a {
    color: #344955;
    opacity: 0.8;
}

.wrapper .fac a:hover {
    transition: 0.2s;
    opacity: 1;
    color: #293847;
}

.wrapper input {
    display: none;
    /* Ocultar el input */
}

.wrapper input:checked~.fab {
    animation: fab-animation 0.4s ease-out forwards;
}

.wrapper input:checked~.fac {
    width: 32px;
    height: 500px;
    animation: fac-animation 0.4s ease-out forwards 0.1s;
    bottom: 40px;
    opacity: 1;
}

@keyframes fab-animation {
    0% {
        transform: rotate(0) scale(1);
    }

    20% {
        transform: rotate(60deg) scale(0.93);
    }

    55% {
        transform: rotate(35deg) scale(0.97);
    }

    80% {
        transform: rotate(48deg) scale(0.94);
    }

    100% {
        transform: rotate(45deg) scale(0.95);
    }
}

@keyframes fab-animation-reverse {
    0% {
        transform: rotate(45deg) scale(0.95);
    }

    20% {
        transform: rotate(-15deg);
    }

    55% {
        transform: rotate(10deg);
    }

    80% {
        transform: rotate(-3deg);
    }

    100% {
        transform: rotate(0) scale(1);
    }
}

@keyframes fac-animation {
    0% {
        transform: scale(1, 1);
    }

    33% {
        transform: scale(0.95, 1.05);
    }

    66% {
        transform: scale(1.05, 0.95);
    }

    100% {
        transform: scale(1, 1);
    }
}
</style>
